import axios from 'axios';

export const state = {
    package_states: [],
    package_types: [],
}

export const getters = {
    getPackageStates: (state) => state.carriers_available,
}

export const actions = {
    async fetchPackageStates({ commit }) {
        const response = await axios.get(`/operation/package/allstates`);
        commit('SET_PACKAGE_STATES', response.data);
    },

    async fetchPackageTypes({ commit }) {
        const response = await axios.get(`/operation/package/alltypes`);
        commit('SET_PACKAGE_TYPES', response.data);
    },
}


export const mutations = {
    SET_PACKAGE_STATES: (state, states) => {
        state.package_states = states;
    }, 
    SET_PACKAGE_TYPES: (state, types) => {
        state.package_types = types;
    }, 
}